import getShippingContext from "@faire/web-api--source/endpoints/www/api/help-center/contexts/brand-orders/brandOrderToken/get";

import {
  InstantAnswerRequiredData,
  InstantAnswerRequiredDataFn,
  SelfServeContext,
} from "../types";

const NO_SHIPPING_CONTEXT: InstantAnswerRequiredData = {
  field: "shippingContext",
  data: undefined,
};

export const ShippingContextDataFn: InstantAnswerRequiredDataFn = (
  context: SelfServeContext
) => {
  const brandOrderToken = context.selectedBrandOrder?.brand_order?.token;
  if (!brandOrderToken) {
    return Promise.resolve(NO_SHIPPING_CONTEXT);
  }

  return getShippingContext(brandOrderToken)
    .then<InstantAnswerRequiredData>((response) => ({
      field: "shippingContext",
      data: response,
    }))
    .catch(() => NO_SHIPPING_CONTEXT) as Promise<InstantAnswerRequiredData>;
};
